import React from "react";
import { useFormikContext } from "formik";
import CopyURL from "components/CopyURL";
import SectionBezel from "components/SectionBezel";

const PreviewFields = () => {
  const { values } = useFormikContext();

  const embedUrl = `${values.url}?embed=true&embed_layout=${values.layout}&silent=true`;

  return (
    <SectionBezel header="Preview" expandable>
      <div className="f6 lh-copy">
        Preview how your configured embed will look.
      </div>
      <div className="pt2">
        <CopyURL
          href={embedUrl}
          customClasses={{
            hasValue: "br4 hairline-1 pv1 pl3 pr2 ba bg-white--hover pointer"
          }}
        />
        <div className="pt2">
          <div className="f6 ba br2 hairline-1 lh-copy pa2 bg-content--secondary">
            <div className="f6 fw6 pb1">NOTE</div>
            <div className="f6">
              Note: the <span className="fw6 token-monospace">silent=true</span>{" "}
              parameter is used for preview purposes only.
            </div>
          </div>
        </div>
      </div>
    </SectionBezel>
  );
};
export default PreviewFields;
